import React, { useState, useEffect } from "react";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CmtCardFooter from "@coremat/CmtCard/CmtCardFooter";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Add } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import CmtCard from "@coremat/CmtCard";
import GridContainer from "@jumbo/components/GridContainer";
import NewsRequests from "services/news";
import { fetchError } from "redux/actions";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import "./style.css";
import CustomSelect from "../Banner/CustomSelect";
import BlogFilePicker from "./BlogFilePicker";
import SelectedFiles from "../Banner/SelectedFiles";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleInput: {
    width: "100%",
  },
  formControl: {
    width: "100%",
  },
  title: {
    color: theme.palette.primary.main,
    marginBlock: "16px",
    fontWeight: "bold",
  },
  previewContainer: {
    width: "100%",
    display: "flex",
    marginTop: "16px",
    justifyContent: "center",
    "& img": {
      width: "190px",
      marginInline: "auto",
      borderRadius: "1rem",
    },
  },
  removeButton: {
    cursor: "pointer",
  },
  noLeftBorder: {
    borderRight: "none",
    borderRadius: "4px 0px 0px 4px",
  },
  inputContainer: {
    width: "100%",
    display: "flex",
  },
  leftButton: {
    borderTopLeftRadius: "0px",
    borderBottomLeftRadius: "0px",
  },
}));

const options = [
  { value: "Image", text: "عکس" },
  { value: "Video", text: "ویدئو" },
  { value: "Array", text: "مجموعه" },
];

const BlogElement = ({ blog }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { message } = useSelector(({ common }) => common);

  const [openDialog, setOpenDialog] = useState(false);
  const [blogTitle, setBlogTitle] = useState("");
  const [blogDesc, setBlogDesc] = useState("");
  const [blogImage, setBlogImage] = useState("");
  const [blogVideo, setBlogVideo] = useState("");
  const [blogLink, setBlogLink] = useState("");
  const [blogIndex, setBlogIndex] = useState("");
  const [categorie, setCategorie] = useState("");
  const [newWindow, setNewWindow] = useState(false);
  const [blogType, setblogType] = useState("Image");
  const [currMedia, setCurrMedia] = useState();

  const [openEditDialog, setopenEditDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);

  const resetState = () => {
    setBlogTitle("");
    setBlogDesc("");
    setBlogImage("");
    setBlogVideo("");
    setBlogLink("");
    setCurrMedia([]);
    getIndex();
  };

  useEffect(() => {
    if (message === "با موفقیت اضافه شد") {
      resetState();
    }
  }, [message]);

  useEffect(() => {
    if (!blog) {
      getIndex();
    }
  }, []);

  useEffect(() => {
    if (blog) {
      setBlogTitle(blog.title);
      setBlogDesc(blog.description);
      setBlogImage(blog.image);
      setBlogVideo(blog.video);
      setBlogLink(blog.link);
      setBlogIndex(blog.index);
      setCategorie(blog.category ? blog.category : "General");
      setNewWindow(blog.linkNewTab);
      if (blog.type) {
        setblogType(blog.type);
      }
      if (blog.type === "Image") {
        setCurrMedia(blog.image);
      } else if (blog.type === "Video") {
        setCurrMedia({ src: blog.video, preview: blog.image });
      } else if (blog.mediaList) {
        if (blog.mediaList.length !== 0) {
          setblogType("Array");
          const data = blog.mediaList.map((item) => {
            if (item.type === "Image") {
              return {
                type: "Image",
                file: item.src,
              };
            } else if (item.type === "Video") {
              return {
                type: "Video",
                file: { src: item.src, preview: item.videoCover },
              };
            }
          });
          setCurrMedia(data);
        }
      }
      if (blog.image && blog.video && blog.mediaList.length === 0) {
        setblogType("Video");
        setCurrMedia({
          src: blog.video,
          preview: blog.image,
        });
      } else if (blog.image && !blog.video && blog.mediaList.length === 0) {
        setblogType("Image");
        setCurrMedia(blog.image);
      } else if (!blog.image && !blog.video && blog.mediaList.length === 0) {
        setblogType("Array");
        setCurrMedia([]);
      }
    }
  }, [blog]);

  const handleAddAndClose = () => {
    const BlogData = {
      title: blogTitle,
      description: blogDesc,
      type: blogType,
      link: blogLink,
      category: categorie,
      linkNewTab: newWindow,
    };
    if (blogIndex) {
      BlogData["index"] = blogIndex;
    }

    if (blogType === "Image") {
      BlogData["image"] = currMedia;
    } else if (blogType === "Video") {
      BlogData["image"] = currMedia.preview;
      BlogData["video"] = currMedia.src;
    } else {
      if (currMedia) {
        if (currMedia.length) {
          const data = currMedia.map((media) => {
            if (media.type === "Image") {
              return {
                src: media.file,
                type: media.type,
              };
            } else if (media.type === "Video") {
              return {
                src: media.file.src,
                type: media.type,
                videoCover: media.file.preview,
              };
            }
          });
          BlogData["mediaList"] = data;
        }
      }
    }
    if (!blogDesc) {
      dispatch(fetchError("توضیحات را وارد نمایید"));
      setOpenAddDialog(false);
    } else {
      dispatch(NewsRequests.addSingleBlog(BlogData));
      resetState();
      setOpenAddDialog(false);
    }
  };

  const handleEditAndClose = () => {
    const BlogData = {
      title: blogTitle,
      description: blogDesc,
      type: blogType,
      link: blogLink,
      category: categorie,
      linkNewTab: newWindow,
    };
    if (blogIndex) {
      BlogData["index"] = blogIndex;
    }

    if (blogType === "Image") {
      BlogData["image"] = currMedia;
    } else if (blogType === "Video") {
      BlogData["image"] = currMedia.preview;
      BlogData["video"] = currMedia.src;
    } else {
      if (currMedia) {
        if (currMedia.length !== 0) {
          const data = currMedia.map((media) => {
            if (media.type === "Image") {
              return {
                src: media.file,
                type: media.type,
              };
            } else if (media.type === "Video") {
              return {
                src: media.file.src,
                type: media.type,
                videoCover: media.file.preview,
              };
            }
          });
          BlogData["mediaList"] = data;
        }
      }
    }
    dispatch(NewsRequests.updateSingleBlog(blog._id || blog.id, BlogData));
    setopenEditDialog(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleRemoveAndClose = () => {
    dispatch(NewsRequests.removeSingleBlog(blog._id || blog.id));
    setOpenDialog(false);
  };

  async function getIndex() {
    try {
      const index = await NewsRequests.getSuggestedIndex();
      setBlogIndex(index);
    } catch (error) {
      console.log("Error loading statistics:", error);
    }
  }

  const handleFillMediaList = (val) => {
    if (blog.type) {
      if (blog.image && !blog.video && val === "Image") {
        setCurrMedia(blog.image);
      } else if (blog.image && blog.video && val === "Video") {
        setCurrMedia({
          src: blog.video,
          preview: blog.image,
        });
      } else if (blog.mediaList.length !== 0 && val === "Array") {
        const data = blog.mediaList.map((item) => {
          if (item.type === "Image") {
            return {
              type: "Image",
              file: item.src,
            };
          } else if (item.type === "Video") {
            return {
              type: "Video",
              file: {
                src: item.src,
                preview: item.VideoCover,
              },
            };
          }
        });
        setCurrMedia(data);
      } else {
        setCurrMedia([]);
      }
    } else {
      if (blog.image && blog.video && val === "Video") {
        setCurrMedia({
          src: blog.video,
          preview: blog.image,
        });
      } else if (blog.image && !blog.video && val === "Image") {
        setCurrMedia(blog.image);
      } else {
        setCurrMedia([]);
      }
    }
  };

  const deleteHandler = (file) => {
    if (blogType === "Image") {
      setCurrMedia("");
    } else if (blogType === "Video") {
      setCurrMedia("");
    } else if (blogType === "Array") {
      const mediaCopy = currMedia.filter((element) => {
        if (element.type === "Image") {
          return element.file !== file;
        } else {
          return element.file.src !== file;
        }
      });
      setCurrMedia(mediaCopy);
    }
  };

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              <Grid item xs={12}>
                <TextField
                  id="questionTitle"
                  label="عنوان خبر"
                  variant="outlined"
                  className={classes.titleInput}
                  value={blogTitle}
                  onChange={(e) => setBlogTitle(e.target.value)}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography className={classes.title}>توضیحات</Typography>
                <CKEditor
                  editor={ClassicEditor}
                  config={{
                    language: "fa",
                    toolbar: [
                      "heading",
                      "|",
                      "bold",
                      "italic",
                      "link",
                      "bulletedList",
                      "numberedList",
                      "blockQuote",
                    ],
                    link: {
                      addTargetToExternalLinks: true,
                      decorators: [
                        {
                          mode: "manual",
                          label: "باز کردن در تب جدید",
                          attributes: {
                            target: "_blank",
                          },
                        },
                      ],
                    },
                  }}
                  data={blogDesc}
                  onChange={(_, editor) => {
                    const data = editor.getData();
                    setBlogDesc(data);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <Grid item xs={12}>
                  <CustomSelect
                    title={"نوع بلاگ"}
                    value={blogType}
                    handleChange={(val) => {
                      setblogType(val);
                      if (blog) {
                        handleFillMediaList(val);
                      } else {
                        setCurrMedia([]);
                      }
                    }}
                    options={options}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className={classes.title}>لینک</Typography>
                  <TextField
                    id="socoreField"
                    label="لینک"
                    variant="outlined"
                    className={classes.formControl}
                    value={blogLink}
                    onChange={(e) => setBlogLink(e.target.value)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography className={classes.title}>ایندکس</Typography>
                  <TextField
                    id="socoreField"
                    label="ایندکس"
                    variant="outlined"
                    type="number"
                    className={classes.formControl}
                    value={blogIndex}
                    onChange={(e) => setBlogIndex(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Grid>
                {blogLink && (
                  <Grid item xs={12}>
                    <Typography className={classes.inputTitle}>
                      پنجره جدید
                    </Typography>
                    <FormControlLabel
                      style={{ marginTop: "15px", paddingRight: "20px" }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={newWindow}
                          onChange={() => setNewWindow((prev) => !prev)}
                          name="new window"
                        />
                      }
                      label="پنجره جدید"
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Typography className={classes.title}>دسته بندی</Typography>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                  >
                    <InputLabel id="demo-simple-select-outlined-label">
                      دسته بندی
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-outlined-label"
                      id="demo-simple-select-outlined"
                      value={categorie}
                      onChange={(e) => setCategorie(e.target.value)}
                      label="دسته بندی"
                    >
                      {/* <MenuItem value={"General"}>جفت پوچ</MenuItem> */}
                      <MenuItem value={"PRNews"}>روابط عمومی</MenuItem>
                      <MenuItem value={"Roshana"}>روشنا</MenuItem>
                      {/* <MenuItem value={"RaheBehesht1403"}>راه بهشت ۱۴۰۳</MenuItem>
                      <MenuItem value={"RaheBehesht1404"}>راه بهشت ۱۴۰۴</MenuItem> */}
                      <MenuItem value={"RaheBehesht1405"}>راه بهشت ۱۴۰۵</MenuItem>
                      <MenuItem value={"Hubble"}>هابل</MenuItem>
                      <MenuItem value={"Result"}>نتایج</MenuItem>
                      <MenuItem value={"Quran"}>قرآن</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <BlogFilePicker type={blogType} setCurrMedia={setCurrMedia} />
                {currMedia && currMedia.length !== 0 ? (
                  <SelectedFiles
                    media={currMedia}
                    type={blogType}
                    handleDelete={(data) => deleteHandler(data)}
                  />
                ) : null}
              </Grid>
            </GridContainer>
          </CmtCardContent>

          <CmtCardFooter
            separator={{
              color: "#bdbdbd",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Box>
              {blog ? (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => setOpenDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    حذف
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => setopenEditDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ویرایش
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => setOpenAddDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ایجاد خبر جدید
                  </Button>
                </>
              )}
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از حدف این سوال اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRemoveAndClose} color="primary">
            تایید
          </Button>
          <Button onClick={handleClose} color="secondary" autoFocus>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={() => setopenEditDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از ویرایش این سوال اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditAndClose} color="primary">
            تایید
          </Button>
          <Button
            onClick={() => setopenEditDialog(false)}
            color="secondary"
            autoFocus
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAddDialog}
        onClose={() => setOpenAddDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            آیا از اضافه کردن این خبر اطمینان دارید ؟
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddAndClose} color="primary">
            تایید
          </Button>
          <Button
            onClick={() => setOpenAddDialog(false)}
            color="secondary"
            autoFocus
          >
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default BlogElement;
